import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {}

const EditIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }} // makes it clickable
      {...props}
    >
      <path
        d="M4.66667 16.3333H5.85417L14 8.1875L12.8125 7L4.66667 15.1458V16.3333ZM3 18V14.4583L14 3.47917C14.1667 3.32639 14.3507 3.20833 14.5521 3.125C14.7535 3.04167 14.9653 3 15.1875 3C15.4097 3 15.625 3.04167 15.8333 3.125C16.0417 3.20833 16.2222 3.33333 16.375 3.5L17.5208 4.66667C17.6875 4.81944 17.809 5 17.8854 5.20833C17.9618 5.41667 18 5.625 18 5.83333C18 6.05556 17.9618 6.26736 17.8854 6.46875C17.809 6.67014 17.6875 6.85417 17.5208 7.02083L6.54167 18H3ZM13.3958 7.60417L12.8125 7L14 8.1875L13.3958 7.60417Z"
        fill={props.fill || "#6D6D70"} // allows dynamic color
      />
    </svg>
  );
};

export default EditIcon;
